function PageGuide() {
  return (
    <button className="bg-[#E39F55] h-[40px] d-row items-center text-white p-[12px] font-inter-semibold text-[14px] rounded-xl hover:bg-[#FCB160]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M7.33325 8H8.66659C9.02021 8 9.35935 7.85952 9.60939 7.60947C9.85944 7.35943 9.99992 7.02029 9.99992 6.66666C9.99992 6.31304 9.85944 5.9739 9.60939 5.72386C9.35935 5.47381 9.02021 5.33333 8.66659 5.33333H6.66659C6.26659 5.33333 5.93325 5.46667 5.73325 5.73333L1.99992 9.33333M4.66659 12L5.73325 11.0667C5.93325 10.8 6.26659 10.6667 6.66659 10.6667H9.33325C10.0666 10.6667 10.7333 10.4 11.1999 9.86667L14.2666 6.93333C14.5238 6.69022 14.674 6.35486 14.684 6.00104C14.694 5.64723 14.563 5.30392 14.3199 5.04667C14.0768 4.78941 13.7414 4.63926 13.3876 4.62926C13.0338 4.61925 12.6905 4.75022 12.4333 4.99333L9.63325 7.59333M1.33325 8.66666L5.33325 12.6667"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <small className="ml-[4px]">Page Guide</small>
    </button>
  );
}

export default PageGuide;
